export default "__VITE_ASSET__d713eaf3__"